// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M18.1,14L15,10.3V4.6L16.3,2H7.7L9,4.6v5.7L5.9,14h5.6v8h1v-8H18.1z M10,5h4v5h-4V5z M14.7,3l-0.5,1H9.8L9.3,3H14.7z
		 M9.7,11h4.6l1.6,2H8.1L9.7,11z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-pin-CBTHMlE9.js.map
